<template>
  <MonacoEditor language="java" />
</template>

<script>
import MonacoEditor from "./components/MonacoEditor.vue";

export default {
  name: "BackCode",
  components: {
    MonacoEditor,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>